// extracted by mini-css-extract-plugin
export default {"LandingPage":"LandingPage_LandingPage__O84nA","logo":"LandingPage_logo__5ONnk"};